import MainContext from "../../context/MainContext";
import { useContext } from "react";
import { useNavigate } from "react-router-dom";
import useIsMobile from "../../hooks/useIsMobile";

const ClientsCard = (props: any) => {
  const { isMobile } = useIsMobile();
  const navigate = useNavigate();

  const { setClient } = useContext(MainContext);

  const handleOnclick = () => {
    setClient(props.client);
    navigate(`/clients/${props.client.id}`);
  };

  return (
    <div
      className="client-card"
      onClick={handleOnclick}
      style={{
        margin: isMobile ? "0 23px" : "",
      }}
    >
      <div
        style={{
          margin: isMobile ? "" : "26px 16px 26px 20px",
        }}
      >
        {/* 
      <input className="offer-card-selector" type={"checkbox"} /> */}
      </div>
      <p
        className="client-card-field"
        style={{ width: "234px", fontSize: "16px" }}
      >
        {props.client.name}
      </p>
      {!isMobile && (
        <>
          <p className="client-card-field" style={{ width: "205px" }}>
            {props.client.referent_name}
          </p>
          <p className="client-card-field" style={{ width: "237px" }}>
            {props.client.mail}
          </p>
          <p className="client-card-field" style={{ width: "160px" }}>
            {props.client.location}
          </p>
        </>
      )}
      <p
        className="client-card-field"
        style={{ width: "135px", color: "#6788a1", textAlign: "right" }}
      >
        € {props.client.amount_spent}
      </p>
    </div>
  );
};
export default ClientsCard;
